import { PageHeader } from 'components/PageHeader';
import { useAssignments } from 'modules/assignments';
import { getTrans } from 'modules/i18n';

export const AssignmentsHeader = () => {
  const { isError } = useAssignments();

  if (isError) return null;

  return (
    <PageHeader
      title={getTrans('assignmentManagementPage.title')}
      withBackBtn
    />
  );
};
